import Colors from '@components/shared/Colors';
import { CountrySelectStyleVariant } from '@contracts';

const OPTION_WIDTH = 216;
const OPTION_FONT_SIZE = '14px';

export const countrySelectStyles = (variant: CountrySelectStyleVariant) => {
  switch (variant) {
    case 'footer':
    case 'dashboard-footer': {
      const primaryColor = 'rgba(255, 251, 231, 0.2)';
      const secondaryColor = variant === 'footer' ? Colors.forestGreen : Colors.navyBlue;

      return {
        control: (base: any) => ({
          ...base,
          backgroundColor: primaryColor,
          borderWidth: 0,
          borderRadius: 2,
          color: Colors.cream,
          cursor: 'pointer',
          height: 50,
          outline: 'none',
          boxShadow: 'none',
          fontSize: OPTION_FONT_SIZE,
          maxWidth: OPTION_WIDTH,

          '*': {
            color: 'inherit !important'
          }
        }),
        menu: (base: any) => ({
          ...base,
          maxWidth: OPTION_WIDTH,
          marginTop: 5
        }),
        menuList: (base: any) => ({
          ...base,
          borderRadius: 2,
          backgroundColor: secondaryColor,
          fontSize: OPTION_FONT_SIZE
        }),
        option: (base: any, state: any) => ({
          ...base,
          backgroundColor: state.isFocused ? Colors.gold : secondaryColor,
          color: state.isFocused ? secondaryColor : Colors.cream,
          paddingLeft: 5,
          cursor: 'pointer'
        }),
        dropdownIndicator: (base: any) => ({
          ...base,
          display: 'none'
        }),
        indicatorSeparator: (base: any) => ({
          ...base,
          display: 'none'
        })
      };
    }
    default: {
      const primaryColor = 'rgba(255, 251, 231, 0.2)';

      return {
        control: (base: any, state: any) => ({
          ...base,
          backgroundColor: primaryColor,
          borderColor: Colors.paleGold,
          borderRadius: state.selectProps.menuIsOpen ? '2px 2px 0 0' : 2,
          color: Colors.navyBlue,
          cursor: 'pointer',
          height: 44,
          outline: 'none',
          boxShadow: 'none',
          fontSize: OPTION_FONT_SIZE,
          '&:hover': {
            borderColor: Colors.paleGold
          },
          '*': {
            color: 'inherit !important'
          }
        }),
        menu: (base: any, state: any) => ({
          ...base,
          marginTop: 0,
          boxShadow: 'none',
          borderRight: `1px solid ${Colors.paleGold}`,
          borderLeft: `1px solid ${Colors.paleGold}`,
          borderBottom: `1px solid ${Colors.paleGold}`,
          borderRadius: state.selectProps.menuIsOpen ? '0 0 2px 2px' : 2
        }),
        menuList: (base: any) => ({
          ...base,
          backgroundColor: primaryColor,
          borderRadius: 2,
          padding: 0,
          fontSize: OPTION_FONT_SIZE
        }),
        option: (base: any, state: any) => ({
          ...base,
          backgroundColor: state.isFocused ? Colors.paleGold25 : Colors.cream,
          color: Colors.navyBlue,
          paddingLeft: 5,
          height: 36,
          cursor: 'pointer',
          '&:not(:last-child)': {
            borderBottom: `1px solid ${Colors.paleGold}`
          }
        }),
        dropdownIndicator: (base: any, state: any) => {
          return {
            ...base,
            color: Colors.navyBlue,
            scale: '0.85',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease'
          };
        },
        indicatorSeparator: (base: any) => ({
          ...base,
          display: 'none'
        }),
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
      };
    }
  }
};
